export default __webpack_public_path__ + "static/media/linkIcon-incomplete.cdb68c04.svg";